module.exports = __webpack_public_path__ + "q.no2.5df93dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/q.no2.jpg
// module id = GyqI
// module chunks = 0